import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import FeaturedArticles from './components/FeaturedArticles';
import CategorySection from './components/CategorySection';
import LatestArticles from './components/LatestArticles';
import FAQSection from './components/FAQSection';

export default function Home() {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '亚洲一区',
    url: 'https://jianfenxiansheng.cn',
    description: '亚洲一区是您探索亚洲优质内容的首选平台，汇聚独家精选资源，覆盖多元文化、娱乐、资讯与生活方式。',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://jianfenxiansheng.cn/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroSection />
          <FeaturedArticles />
          <CategorySection />
          <LatestArticles />
          <FAQSection />
        </main>
        <Footer />
      </div>
    </>
  );
}